<template>
    <div>
        <MainHeader />
        <div class="page">
            <div class="container">
                <h2>About Geofolio</h2>
                <p>
                    Geofolio is a small project with a big vision: to make the world's environmental data accessible and 
                    understandable for everyone. It was started as a prototype and a side project by Koko Alberti in 2019, and he is currently working
                    full time on it to implement new features and quality improvements.
                </p>
                <p>
                    The factsheets are a work in progress, and we're open to feedback, suggestions, and collaboration to improve them. Keep in touch via <a href="https://twitter.com/geofolio">@geofolio</a> and <a href="https://twitter.com/kokoalberti">@kokoalberti</a> for the latest updates.
                </p>
                <p>
                    Send an e-mail to <a href="mailto:info@geofolio.org">info@geofolio.org</a> if you'd like to develop a custom factsheet together around a 
                    theme that you're interested in.
                </p>
            </div>
        </div>
        <Footer />
    </div>
</template>

<script>
  import MainHeader from '@/components/generic/MainHeader.vue'
  import Footer from '@/components/generic/Footer.vue'

  export default {
    name: 'about',
    components: {
      MainHeader, Footer
    }
  }
</script>

<style scoped>

div.page {
    font-size:1.1em;
    color:#666;
}
h1 {
    font-size:1.3em;
    font-weight:600;
    margin-top:15px;
}

h2 {
    font-size:1.2em;
    font-weight:600;
    margin-top:15px;
}

h3 {
    font-size:1.05em;
    font-weight:600;
    margin-top:15px;
}
p {
    line-height:1.4em;
}
</style>